module.exports = __webpack_public_path__ + "static/media/googlelogin.56122dad.png";